import type Quill from 'quill';
import {deleteRange} from 'quill/modules/keyboard';

import {isNil} from 'ramda';

import {TEMPLATE_TOKEN} from './TEMPLATE_TOKEN';
import {TemplateTokenBlot} from './TemplateTokenBlot';

const readTokenCode = (insert: unknown) => {
  if (typeof insert !== 'object' || insert === null || !(TEMPLATE_TOKEN.blotName in insert)) {
    return null;
  }

  return TemplateTokenBlot.parse(insert[TEMPLATE_TOKEN.blotName])?.code ?? null;
};

/**
 * Copies or cuts a selection that holds a token with the canonical `{{ code }}` as plain text and
 * as HTML. Quill's own copy writes `getText()`, which drops every embed. A selection without a
 * token is left to Quill.
 */
export function writeTemplateTokenClipboard(editor: Quill, event: ClipboardEvent) {
  const range = editor.getSelection();

  if (isNil(range) || range.length === 0 || isNil(event.clipboardData)) {
    return;
  }

  const ops = editor.getContents(range.index, range.length).ops;
  const codes = ops.map((op) => readTokenCode(op.insert));

  if (codes.every(isNil)) {
    return;
  }

  event.preventDefault();
  event.clipboardData.setData(
    'text/plain',
    ops
      .map((op, index) => {
        const code = codes[index];
        if (!isNil(code)) {
          return TEMPLATE_TOKEN.toPlaceholder(code);
        }
        return typeof op.insert === 'string' ? op.insert : '';
      })
      .join('')
  );
  event.clipboardData.setData('text/html', editor.getSemanticHTML(range.index, range.length));

  if (event.type === 'cut' && editor.isEnabled()) {
    deleteRange({range, quill: editor});
  }
}
